<template>
  <div>
    <v-row
      class="align-center justify-start mx-0"
      style="margin-top:20px; position:fixed; z-index: 10; min-width: -webkit-fill-available;"
    >
      <v-row>
        <v-col cols="5">
          <span
            class="text-start"
            style="color:#777; font-size:30px;"
          >Espacios</span>
        </v-col>
        <v-spacer />

        <v-col cols="1" style="min-width: fit-content;" class="pa-1">
          <v-btn icon color="admiraFontGray" class="py-0 my-0" style="margin-left:-35px;">
            <v-icon style="cursor: pointer; font-size:28px;" @click="closeLeftMenu">mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      
    </v-row>
    
    <v-container>
        <v-col cols="12">
            <v-row>
              <v-col cols="12" style="margin: 0 0 50px 0;margin-top: 65px">
                <v-row style="padding:3%;cursor:pointer;" v-for="space in allSpaces" :key="space.idSpace" @click="selectSpace(space)">
                  <v-icon style="padding-right:4%">mdi-office-building</v-icon>
                  <p style="margin:0px;color:#777;">{{space.name}}</p>
                </v-row>
              </v-col>
            </v-row>
        </v-col>

      <div style="position: fixed; bottom: 0;background-color: white; width: 100%;">
        <v-divider style="mx-0"></v-divider>

        <v-row class="mb-2 pr-6">

          <v-col cols="6">
            <v-btn
              @click="loading ? false : addNewSpace(objQueue)"
              class="justify-center"
              rounded
              depressed
              color="admiraGreen"
              small
              dark
              width="120"
            >Crear Sitio</v-btn>
          </v-col>
        </v-row>
      </div>
    </v-container>

  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";
import { HollowDotsSpinner } from "epic-spinners";

export default {
  name: "LeftMenuAddNewSpace",
  data: () => ({
    typeQueueModel: "",
    types: [
      { type: 'Fila única', idType: 1 },
      { type: 'Fila única con tiquets', idType: 2 },
      { type: 'Fila multipuesto con tiquets', idType: 3 },
    ],
    allSpacesModel: "",
    isSaving: false,
    deleteDialog: false,
    show: true,
    loading: false,
    valid: false,
    showAlertType: false,
    showAlertSpace: false,
    showAlertName: false,

  }),
  components: { HollowDotsSpinner },
  computed: {
    ...mapState("queues", [ "showRightMenu","objQueue", "allSpaces","asociatedSpaces"]),
        ...mapState("app", ["actualProject"]),

  },
  methods: {
    ...mapMutations("queues", ["setActualSpaceMutation","closeLeftMenuMutation",
      "closeRightMenuMutation",
    ]),
    ...mapActions("queues", ["getAllSpaces",
      "addQueueStore","getAsociatedResourcesStore","getAllQueues"
    ]),
    addNewSpace(){
      console.log("añadimos espacio");
      
    },
   async selectSpace(campaign) {  
          
      await this.setActualSpaceMutation(campaign);
       var mobile = {
        Android: function() {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function() {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function() {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function() {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function() {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function() {
          return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
        }
      };

      if(mobile.any() != null){
      this.$router.push({
        name: "ResumeSpaceMobile",
        params: { idQueue: campaign.idSpace },
      });
      }else{
      this.$router.push({
        name: "ResumeSpace",
        params: { idQueue: campaign.idSpace },
      });
      }

      this.closeLeftMenu();
    },
    closeLeftMenu() {      
      this.closeLeftMenuMutation();
    }
  },
  async created() {
    let idProject = this.actualProject.id;
     await this.getAllSpaces(idProject);  
    await console.log(this.allSpaces);
        
  },
  mounted() {
    
  },
  destroyed() {
    
  }
};
</script>

<style scoped>
>>> .v-navigation-drawer {
  width: 418px !important;
}

.newtext {
  font-family: "Roboto", sans-serif;
}
a {
  text-decoration: none;
}
.admira-icon {
  font-family: "Admira icons";
}
.boxImage {
  background-color: #f5f5f5;
  height: 255px;
  padding: 110px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/LeftMenuAddNewSpace.vue